import { InventoryApi } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useInventories = () => {
  return useQuery([INVENTORIES_QUERY_KEYS.INVENTORIES], async () => {
    const inventories = await InventoryApi.getInventories()

    return inventories.data
  })
}
